import { render, staticRenderFns } from "./GBWhatsApp.vue?vue&type=template&id=cf82fe22&scoped=true"
import script from "./GBWhatsApp.vue?vue&type=script&lang=js"
export * from "./GBWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./GBWhatsApp.vue?vue&type=style&index=0&id=cf82fe22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf82fe22",
  null
  
)

export default component.exports